import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ContextHome } from "./contextHomeCloude/contextHome";
import { sortData, readList, DataResponse, sortDataByName } from "./helpFunction/helpFunction";
import { Menu } from "./views/menu/Menu";
import { DataListFtp } from "./views/DataListFtp/DataListFtp";
import { Stopka } from "./views/Stopka/Stopka";
import { ClickForConnect } from "./views/ClickForConnect/ClickForConnect";
import { Spiner } from "./spinerListki/spiner";

export type loadingType = "Czekaj ..." | "" | "Pobieram ...";
export const Cloude = () => {
	const [loading, setLoading] = useState<boolean | loadingType>(false);
	const [reload, setReload] = useState<boolean>(false);
	const [connect, setConnect] = useState(false);
	const [data, setData] = useState<DataResponse[] | []>([]);
	const [path, setPath] = useState<string>("");
	const [loadingProgress, setLoadingProgress] = useState<number | null>(null);
	const [LongPressed, setLongPressed] = useState<boolean>(false);
	const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
	const [firstTach, setFirstTach] = useState(false);

	const [menuEnabled, setMenuEnabled] = useState<boolean>(true);

	const listAll = async () => {
		setLoading(true);
		setData(
			await sortDataByName(
				await sortData(
					await readList({
						setConnect,
						path,
						setPath,
						setLoadingProgress,
					}),
				),
			),
		);
		setLoading(false);
	};

	useEffect(() => {
		(async () => {
			if (connect) {
				await listAll();
			}
		})();
	}, [reload]);

	// useEffect(() => {
	// 	// setLoading(false);
	// }, []);

	const clearAndReload = () => {
		setLoading(false);
		setLoadingProgress(null);
		setReload(!reload);
		setLongPressed(false);
		setSelectedFiles([]);
		setMenuEnabled(true);
		document.querySelectorAll(".selected").forEach((e) => {
			e.classList.remove("selected");
		});
	};
	return (
		<>
			<ContextHome.Provider
				value={{
					setLoading,
					loading,
					setReload,
					connect,
					setConnect,
					listAll,
					setData,
					data,
					reload,
					path,
					setPath,
					setLoadingProgress,
					LongPressed,
					setLongPressed,
					selectedFiles,
					setSelectedFiles,
					loadingProgress,
					clearAndReload,
					setMenuEnabled,
					setFirstTach,
					firstTach,
				}}
			>
				{loading && <Spiner progress={loadingProgress} napis={loading} />}
				{menuEnabled && <Menu />}
				{!connect && <ClickForConnect />}
				{connect && <DataListFtp />}
				<Stopka />
			</ContextHome.Provider>
		</>
	);
};
